"use strict";


export class Benefits {
    #OPEN_BTNS;
    #CLOSE_BTNS;
    #MODALS;

    constructor() {
        this.#OPEN_BTNS = document.querySelectorAll("[data-open]");
        this.#CLOSE_BTNS = document.querySelectorAll("[data-close]");
        this.#MODALS = document.querySelectorAll("[data-modal]");

        this.initEvents();
    }

    initEvents = () => {
        this.#OPEN_BTNS.forEach((btn) => {
            btn.addEventListener("click", () => {
                const targetName = btn.getAttribute("data-open");
                this.openModal(targetName);
            });
        });

        this.#CLOSE_BTNS.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                const modal = e.target.closest("dialog");
                if (modal) this.closeModal(modal);
            });
        });

        this.#MODALS.forEach((modal) => {
            modal.addEventListener("click", (e) => {
                if (e.target === modal) {
                    this.closeModal(modal);
                }
            });
        });
    };

    openModal = (targetName) => {
        const targetModal = document.querySelector(`[data-modal="${targetName}"]`);
        if (targetModal) {
            targetModal.classList.add("is-confirm-animation");
            targetModal.showModal();
        }
    };

    closeModal = (modalElement) => {
        if (modalElement) {
            modalElement.close();
            modalElement.classList.remove("is-confirm-animation", "is-complete-animation");
        }
    };
}